// The12 industry-specific NECS images supplied for Explore and property-admin views.
// Kept separate from the Services in Action gallery: these are industry illustrations.
export const COMMERCIAL_INDUSTRY_IMAGES = {
  office: {
    src: '/images/commercial-industries/office.webp',
    alt: 'NECS team cleaning and polishing floors in a corporate office lobby',
  },
  retail: {
    src: '/images/commercial-industries/retail.webp',
    alt: 'NECS team pressure washing a retail center storefront walkway',
  },
  gas_station: {
    src: '/images/commercial-industries/gas_station.webp',
    alt: 'NECS team scrubbing the forecourt of a gas station and convenience store',
  },
  school: {
    src: '/images/commercial-industries/school.webp',
    alt: 'NECS team cleaning the entrance and outdoor seating at a school',
  },
  medical: {
    src: '/images/commercial-industries/medical.webp',
    alt: 'NECS team cleaning the reception and waiting area of a medical clinic',
  },
  warehouse: {
    src: '/images/commercial-industries/warehouse.webp',
    alt: 'NECS team maintaining floors and work areas inside a warehouse',
  },
  restaurant: {
    src: '/images/commercial-industries/restaurant.webp',
    alt: 'NECS team deep cleaning restaurant floors, furniture and windows',
  },
  church: {
    src: '/images/commercial-industries/church.webp',
    alt: 'NECS team cleaning pews, aisles and the sanctuary of a church',
  },
  mall: {
    src: '/images/commercial-industries/mall.webp',
    alt: 'NECS team cleaning common areas inside a multilevel shopping mall',
  },
  bank: {
    src: '/images/commercial-industries/bank.webp',
    alt: 'NECS team cleaning a bank lobby, teller counters and customer seating',
  },
  stadium: {
    src: '/images/commercial-industries/stadium.webp',
    alt: 'NECS team cleaning stadium walkways and exterior windows',
  },
  airport: {
    src: '/images/commercial-industries/airport.webp',
    alt: 'NECS team cleaning airport terminal floors, gate seating and windows',
  },
};

export const getCommercialIndustryImage = type => {
  const key = typeof type === 'string' ? type.trim().toLowerCase() : '';
  return Object.prototype.hasOwnProperty.call(COMMERCIAL_INDUSTRY_IMAGES, key)
    ? COMMERCIAL_INDUSTRY_IMAGES[key]
    : null;
};